import { environment } from '../../../../environments/environment';

type EnvironmentName = 'local' | 'dev' | 'qa' | 'staging' | 'production';

export const getCurrentEnvironmentName = (): EnvironmentName => {
  if (environment.isProd) {
    return 'production';
  }

  if (environment.isStaging) {
    return 'staging';
  }

  if (environment.isQa) {
    return 'qa';
  }

  if (environment.isDev) {
    return 'dev';
  }

  return 'local';
};
